module.exports = __webpack_public_path__ + "img/monogastric@2x.png";